$(".module-style__new-boat .module-content-block").each(function() {
    $(this).find(".broschuere-download, .btn").appendTo($(this).find(".headline-wrapper"));

});